function normalizeValue(value) {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value).trim()
}

const QIABOT_USER_IDENTIFIER_PREFIX = 'hb_v3_user_'
const QIABOT_GUEST_IDENTIFIER_PREFIX = 'hb_v3_guest_'

function buildQiabotUserIdentifier(userId) {
  const normalized = normalizeValue(userId)
  if (!normalized) {
    return ''
  }

  return normalized.indexOf(QIABOT_USER_IDENTIFIER_PREFIX) === 0
    ? normalized
    : `${QIABOT_USER_IDENTIFIER_PREFIX}${normalized}`
}

function buildQiabotGuestIdentifier(options) {
  const storedIdentifier = normalizeValue(options && options.storedIdentifier)
  if (storedIdentifier.indexOf(QIABOT_GUEST_IDENTIFIER_PREFIX) === 0) {
    return storedIdentifier
  }

  const createIdentifier = options && options.createIdentifier
  return typeof createIdentifier === 'function' ? normalizeValue(createIdentifier()) : ''
}

function normalizeQiabotEmail(userEmail, userName) {
  const email = normalizeValue(userEmail)
  if (email) {
    return email
  }

  const fallbackName = normalizeValue(userName)
  return fallbackName.indexOf('@') > -1 ? fallbackName : ''
}

function looksLikePhone(value) {
  const text = normalizeValue(value)
  if (!text || text.indexOf('@') > -1) {
    return false
  }

  const digits = text.replace(/\D/g, '')
  return digits.length >= 6 && /^[+\d\s().-]+$/.test(text)
}

function normalizeQiabotPhone(userPhone, userName) {
  const phone = normalizeValue(userPhone)
  if (phone) {
    return phone
  }

  const fallbackName = normalizeValue(userName)
  return looksLikePhone(fallbackName) ? fallbackName : ''
}

function buildQiabotUserInfo(options) {
  const isAuthenticated = !(options && options.isAuthenticated === false)
  const userId = isAuthenticated ? normalizeValue(options && options.userId) : ''
  const guestIdentifier = normalizeValue(options && options.guestIdentifier)
  const userIdentifier = buildQiabotUserIdentifier(userId)
  const userName = normalizeValue(options && options.userName)
  const userEmail = normalizeQiabotEmail(options && options.userEmail, userName)
  const userPhone = normalizeQiabotPhone(options && options.userPhone, userName)
  const remark = normalizeValue(options && options.remark)
  const customAttr = {}
  const config = {}

  if (userIdentifier) {
    config.identifier = userIdentifier
    customAttr.ID = String(userId)
  } else if (guestIdentifier) {
    config.identifier = String(guestIdentifier)
    customAttr.guest_id = String(guestIdentifier)
    customAttr.identity_type = 'guest'
  }
  if (userName) {
    config.name = userName
    customAttr.username = userName
  }
  if (userEmail) {
    config.email = userEmail
    customAttr.email = userEmail
  }
  if (userPhone) {
    config.phone = userPhone
    customAttr.phone = userPhone
  }
  if (remark) {
    customAttr.remark = remark
  }
  if (Object.keys(customAttr).length) {
    config.custom_attr = customAttr
    config.metadata = Object.assign({}, customAttr)
  }

  return config
}

function mergeQiabotCustomAttr(config) {
  const metadata = config && config.metadata
  const customAttr = config && config.custom_attr
  const merged = Object.assign({}, metadata || {}, customAttr || {})

  return Object.keys(merged).length ? merged : undefined
}

function assignNormalizedValue(target, key, value) {
  const normalized = normalizeValue(value)
  if (normalized) {
    target[key] = normalized
  }
}

function buildQiabotUserDataMessage(config, autoCreateConversation) {
  const message = {
    type: 'user_data'
  }

  assignNormalizedValue(message, 'email', config && config.email)
  assignNormalizedValue(message, 'identifier', config && config.identifier)
  assignNormalizedValue(message, 'identifier_hash', config && config.identifier_hash)
  assignNormalizedValue(message, 'name', config && config.name)
  assignNormalizedValue(message, 'phone', config && config.phone)

  const customAttr = mergeQiabotCustomAttr(config)
  if (customAttr) {
    message.custom_attr = customAttr
    message.metadata = Object.assign({}, customAttr)
  }

  message.autoCreateConversation = Boolean(autoCreateConversation)

  return message
}

function buildQiabotPageContextMessage(pageContext) {
  return {
    type: 'page_context',
    href: normalizeValue(pageContext && pageContext.href),
    referrer: normalizeValue(pageContext && pageContext.referrer)
  }
}

function buildQiabotFrameMessages(config, pageContext, autoCreateConversation) {
  return [
    buildQiabotPageContextMessage(pageContext),
    buildQiabotUserDataMessage(config, autoCreateConversation)
  ]
}

function buildQiabotLogPayload(config) {
  if (!config || typeof config !== 'object') {
    return {}
  }

  return JSON.parse(JSON.stringify(config))
}

module.exports = {
  buildQiabotFrameMessages,
  buildQiabotGuestIdentifier,
  buildQiabotLogPayload,
  buildQiabotUserIdentifier,
  buildQiabotUserInfo,
  buildQiabotPageContextMessage,
  buildQiabotUserDataMessage,
  normalizeQiabotEmail
}
